
  <div class="breadcrumbs overlay">
    <div class="container">
        <div class="bread-inner">
            <div class="row">
                <div class="col-12">
                    <h2>REALISATIONS</h2>
                </div>
            </div>
        </div>
    </div>
</div><br>
  <!-- Start qui sommes nus choose -->
  <!-- Start qui sommes nus choose -->
  <section class="why-choose section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 ">
                <!-- Start Choose Left -->
                <div class="choose-left"><br>
                    <h3>REALISATIONS</h3>
                   
                    <div class="card col-md-12 card-custom">
                        <div class="card-body">
                            <h4 class="card-title">CONTRÔLE DES FINANCES PUBLIQUES</h4>
                            <ul>
                                <li>Publication du rapport annuel sur les comptes de l'État</li>
                                <li>Rapport sur la situation des finances publiques du Bénin</li>
                                <li>Audit des principales entreprises publiques du portefeuille de l'État</li>
                                <li>Rapports spéciaux sur la gestion des collectivités territoriales</li>
                            </ul>
                        </div>
                    </div>

                        <div class="justify-content-end" >
                            <a (click)="goToMission()" href="javascript: void(0);" style=" font-family: '';font-size: 15px; justify-content: center;"  class="btn btn-primary text-white" rel="noopener" >A propos</a>
                        </div>
                </div>&nbsp;&nbsp;&nbsp;

              
                <!-- End Choose Left -->
            </div><br>
            <div class="col-md-6 d-flex justify-content-center align-items-center mt-4">
                <img src="../../../assets/img/ccb-batiment.jpg" class="img-fluid rounded" alt="Cour des Comptes du Bénin" style="max-height: 350px;">
            </div>
        </div>
    </div>
</section><br>
<!--/ End  -->
